import * as React from "react";
import { useState } from "react";
import { Formik, Form } from "formik";
import { Button, Modal } from "components/bootstrap";
import { FormikInput, Icon, ModalSubmit } from "components/common";
import usePermissions from "hooks/usePermissions";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import useDataLakeRetention from "data-lake/hooks/useDataLakeRetention";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { formatRetentionLabel, validateRetention } from "data-lake/logic/Utils";
const DataLakeRetentionForm = ({ title, config }) => {
  const { isPermitted } = usePermissions();
  const [showModal, setShowModal] = useState(false);
  const { onUpdateDataLakeRetentionMutation } = useDataLakeRetention();
  const sendTelemetry = useSendTelemetry();
  const openModal = (event) => {
    event.stopPropagation();
    setShowModal(true);
  };
  const onCloseModal = () => {
    setShowModal(false);
  };
  const validate = (values) => {
    let errors = {};
    if (!values.retentionTime) {
      errors = { retentionTime: "Invalid duration." };
    }
    return errors;
  };
  const onSubmit = ({ retentionTime }) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.DATALAKE.RETENTION_CONFIG_SAVED, {
      app_pathname: "streams"
    });
    const retention_time = retentionTime === "0" ? null : retentionTime;
    onUpdateDataLakeRetentionMutation({ streamId: config.stream_id, retentionTime: retention_time }).then(
      () => setShowModal(false)
    );
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Button,
    {
      disabled: !isPermitted("data_lake_backend_config:update"),
      bsSize: "sm",
      onClick: openModal,
      title: "Configure Retention"
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "settings" }),
    " Configure Retention"
  ), showModal && /* @__PURE__ */ React.createElement(Modal, { show: showModal, onHide: onCloseModal }, /* @__PURE__ */ React.createElement(
    Formik,
    {
      initialValues: { retentionTime: config.retention_time },
      onSubmit,
      validate
    },
    ({ values, isSubmitting, isValidating }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, `Data Lake Retention for ${title}`)), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(
      FormikInput,
      {
        type: "text",
        name: "retentionTime",
        id: "retentionTime",
        placeholder: "P1D",
        label: "Maximum number of days in the Data Lake",
        help: /* @__PURE__ */ React.createElement(React.Fragment, null, "Define how many days to keep archives before deleting them. When 0 P0D is set, automatic deletion is disabled."),
        addonAfter: formatRetentionLabel(values.retentionTime),
        validate: validateRetention,
        required: true
      }
    )), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
      ModalSubmit,
      {
        submitButtonText: "Update",
        submitLoadingText: "Updating retention",
        onCancel: onCloseModal,
        disabledSubmit: isValidating,
        isSubmitting
      }
    )))
  )));
};
export default DataLakeRetentionForm;
